'use strict';

module.exports = function ( list, video ) {
    var data = {
        video: [],
        subtitles: []
    };

    /**
     * Get subtitle uri.
     *
     * @param {Function} callback - result handler
     *
     * @this subtitleList
     */
    function getSubtitleUri ( callback ) {
        if ( this.uri ) {
            callback(false, this.uri);
        } else {
            video.getUrl(this.id, callback);
        }
    }

    list.forEach(function ( item ) {
        switch ( item.type ) {
            case 'video':
                data.video.push(item);
                break;
            case 'sub':
                data.subtitles.push({
                    id: item.id,
                    title: item.name,
                    lang: item.languages[0] || '',
                    uri: item.url,
                    getUri: getSubtitleUri
                });
                break;
        }
    });

    list.sort(function ( itemA, itemB ) {
        if ( !itemB.quality ) {
            return 0;
        }

        if ( !itemA.quality ) {
            return -1;
        }

        return itemB.quality.width - itemA.quality.width;
    });

    return data;
};
